import {
    Routes,
    Route,
    Outlet,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import NotFound from "./components/NotFound";
import Product from "./pages/Product";
import { Container } from "react-bootstrap";
import Warranty from "./pages/Policy/Warranty";
import Delivery from "./pages/Policy/Delivery";
import Privacy from "./pages/Policy/Privacy";
import TermsAndConditions from "./pages/Policy/TermsAndConditions";
import Returns from "./pages/Policy/Returns";
import CookieConsent from "./components/CookieConsent";
import Cart from "./pages/Cart";
import Order from "./pages/Order";
import usePageMeta from "./hooks/usePageMeta";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./contexts/Cart";
import { LANGUAGES, LanguageProvider, pathInLanguage } from "./contexts/Language";

// Rendered inside BrowserRouter by src/index.js, and inside StaticRouter by
// scripts/prerender.js, which draws each page into its HTML at build time.
export default function App() {
    // const { i18n } = useTranslation();
    // const navigate = useNavigate();
    // const location = useLocation();
    // const { pathname } = location;

    // useEffect(() => {
    //     try {
    //         if (i18n.language === "en") {
    //             setTimeout(() => {
    //                 if (!window.location.href.includes("localhost:3000")) {
    //                     i18n.changeLanguage("ka");
    //                     if (pathname.includes("/en")) {
    //                         navigate(pathname.replace("/en", ""));
    //                     }
    //                 }
    //             }, 5_000);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }, [i18n]);

    return (
        <LanguageProvider>
            <CartProvider>
                <Routes>
                    {/* The same pages under each language's path: "/", "/en", … */}
                    {LANGUAGES.map((language) => (
                        <Route
                            key={language}
                            path={pathInLanguage("/", language)}
                            element={<Layout />}
                        >
                            <Route index element={<Home />} />
                            <Route path=":productId" element={<Product />} />
                            <Route path="cart" element={<Cart />} />
                            <Route path="order" element={<Order />} />
                            <Route path="policies/warranty" element={<Warranty />} />
                            <Route path="policies/delivery" element={<Delivery />} />
                            <Route path="policies/returns" element={<Returns />} />
                            <Route path="policies/privacy" element={<Privacy />} />
                            <Route
                                path="policies/terms-and-conditions"
                                element={<TermsAndConditions />}
                            />

                            <Route path="*" element={<NotFound />} />
                        </Route>
                    ))}
                </Routes>
                <ScrollToTop />
            </CartProvider>
        </LanguageProvider>
    );
}

function Layout() {
    usePageMeta();

    return (
        <div>
            <Header />
            {/* <div style={{ minHeight: "48px" }}></div> */}
            <Container>
                <Outlet />
            </Container>
            <Footer />
            <CookieConsent />
        </div>
    );
}
